import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { sequenceActionNext } from '@laramie/ui';
import { TableCustom, MessageModal } from '../../common';
import { CloneObject, GetFieldMes } from '../../../utils/helpers';
import EmisionCuotaModal from '../EmisionCuotaModal';
import { getDateToString } from '../../../utils/convert';
import { isNull } from '../../../utils/validator';


const EmisionCuotasGrid = (props) => {

  //hooks
  const [state, setState] = useState({
      idEmisionDefinicion: 0,
      disabled: false,
      showMessage: false,
      showForm: false,
      modeFormEdit: false,
      rowForm: null,
      listCuotas: [],
      listVariables: [],
      listFunciones: []
  });

  const dispatch = useDispatch();
  const sequenceValue = useSelector( (state) => state.sequence.value );

  const mount = () => {
    const listCuotas = props.data.listCuotas.filter(x => x.state !== 'r');
    setState(prevState => {
      return {...prevState,
        idEmisionDefinicion: props.data.idEmisionDefinicion,
        listCuotas: listCuotas,
        listVariables: props.data.listVariables,
        listFunciones: props.data.listFunciones
      };
    });
  }
  useEffect(mount, [props.data]);

  const allowEdit = (row) => !(row.fechaVencimiento1Masivo || row.fechaVencimiento2Masivo);

  const cellA = (data) =>    <div className='action'>
                                {!props.disabled && (
                                  <div onClick={ (event) => handleClickEmisionCuotaAdd() } className="link">
                                      <span className="material-symbols-outlined" title="Nuevo">add</span>
                                  </div>
                                )}
                              </div>
  const cellVMR = (data) =>  <div className='action'>
                                  <div onClick={ (event) => handleClickEmisionCuotaView(data.value) } className="link">
                                  <span className="material-symbols-outlined" title="Ver">search</span>
                                  </div>
                                  {!props.disabled && allowEdit(data.row.original) && (
                                  <div onClick={ (event) => handleClickEmisionCuotaModify(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Modificar">stylus</span>
                                  </div>
                                  )}
                                  {!props.disabled && allowEdit(data.row.original) && (
                                  <div onClick={ (event) => handleClickEmisionCuotaRemove(data.value) } className="link">
                                      <span className="material-symbols-outlined" title="Eliminar">delete</span>
                                  </div>
                                  )}                                 
                              </div>

  const tableColumns = [
    { Header: 'Mes', Cell: (props) => {
      const row = props.row.original;
      return GetFieldMes(row.mes, 'name');
    }, id: 'mes', accessor: 'id', width: '12%' },
    { Header: 'Cuota', accessor: 'cuota', width: '12%', disableSortBy: true },
    { Header: '1° Vto.', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaVencimiento1', width: '18%' },
    { Header: '2° Vto.', Cell: (props) => getDateToString(props.value, false), accessor: 'fechaVencimiento2', width: '18%' },
    { Header: 'Descripción', accessor: 'descripcion', width: '30%', disableSortBy: true  },
    { Header: cellA, Cell: cellVMR, id:'abm', accessor: 'id', width: '10%', disableGlobalFilter: true, disableSortBy: true }
  ];


  //handles
  const handleClickEmisionCuotaAdd = () => {
    const idTemporal = (-1)*sequenceValue; //los registros temporales tienen id negativa
    setState(prevState => {
      const rowForm = {
        id: idTemporal,
        idEmisionDefinicion: state.idEmisionDefinicion,
        cuota: 0,
        mes: 0,
        descripcion: "",
        formulaCondicion: "",
        anioTabla: "",
        mesTabla: 0,
        anioDDJJ: "",
        mesDDJJ: 0,
        fechaVencimiento1: null,
        fechaVencimiento2: null,
        fechaVencimiento1Original: null,
        fechaVencimiento2Original: null,
        fechaVencimiento1Masivo: null,
        fechaVencimiento2Masivo: null,
        orden: 0,
        state: 'a'
      };
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
    dispatch( sequenceActionNext() );
  }
  const handleClickEmisionCuotaView = (id) => {
    setState(prevState => {
      const rowForm = state.listCuotas.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: false, rowForm: rowForm};
    });
  }
  const handleClickEmisionCuotaModify = (id) => {
    setState(prevState => {
      const rowForm = state.listCuotas.find(x => x.id === id);
      return {...prevState, showForm: true, modeFormEdit: true, rowForm: rowForm};
    });
  }
  const handleClickEmisionCuotaRemove = (id) => {
    if (props.requireConfirmRemove) {
      setState(prevState => {
        const rowForm = state.listCuotas.find(x => x.id === id);
        return {...prevState, showMessage: true, rowForm: rowForm};
      });
    }
    else {
      const rowForm = state.listCuotas.find(x => x.id === id);
      const row = CloneObject(rowForm);
      RemoveEmisionCuota(row);
    }
  } 

  //funciones
  function RemoveEmisionCuota(row) {
    row.state = 'r';
    props.onChange('EmisionCuota', row);
  }

  function UpdateEmisionCuota(row) {
    row.state = isNull(state.listCuotas.find(x => x.id === row.id)) ? 'a' : 'm';
    props.onChange('EmisionCuota', row);
  }

  return (
  <>

    {state.showMessage && 
        <MessageModal
            title={"Confirmación"}
            message={"¿Está seguro de borrar el registro?"}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
            }}
            onConfirm={() => {
              const row = CloneObject(state.rowForm);
              setState(prevState => {
                  return {...prevState, showMessage: false, rowForm: null};
              });
              RemoveEmisionCuota(row);
            }}
        />
    }

    {state.showForm && 
        <EmisionCuotaModal
            disabled={!state.modeFormEdit}
            data={{
              entity: state.rowForm,
              listVariables: state.listVariables,
              listFunciones: state.listFunciones
            }}
            periodo={props.periodo}
            procesaRubros={props.procesaRubros}
            onDismiss={() => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
            }}
            onConfirm={(row) => {
              setState(prevState => {
                  return {...prevState, showForm: false, rowForm: null};
              });
              UpdateEmisionCuota(row);
            }}
        />
    }

    <TableCustom
        showFilterGlobal={false}
        className={'TableCustomBase'}
        columns={tableColumns}
        data={state.listCuotas}
    />

  </>
  );
}

EmisionCuotasGrid.propTypes = {
  disabled: bool,
  requireConfirmRemove: bool,
  data: object.isRequired,
  periodo: string.isRequired,
  procesaRubros: bool.isRequired,
  onChange: func.isRequired
};

EmisionCuotasGrid.defaultProps = {
  disabled: false,
  requireConfirmRemove: true
};

export default EmisionCuotasGrid;